import { inject } from "@angular/core";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { ROUTES } from "@app/shared/constants/routes.constants";
import { Router } from "@angular/router";

export const TwoFactorAuthenticationGuard = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate([ROUTES.LOGIN]);
    return false;
  }

  if (authService.key2FA && authService.is2faAuthenticated()) {
    router.navigate([ROUTES.HOME]);
    return false;
  }

  return true;
};
